import React, { useState } from 'react';
import './HubLogin.css';

const HubLogin = () => {
  const [phone, setPhone] = useState('');
  return (
    <div className="hub-login-root">
      <div className="login-card">
        <h2>Hub Staff Login</h2>
        <input type="text" placeholder="Enter Phone Number" value={phone} onChange={(e) => setPhone(e.target.value)} />
        <button className="login-btn">Send OTP</button>
      </div>
    </div>
  );
};
export default HubLogin;